module.exports={author:"Matt Nelson",date:"12/07/2021",publishDate:"12/07/2021",highlighted:!1,tags:"",title:"Rachel"};